import { ViewMoreContainer } from './styles';
import { ViewMoreButtonType } from './types';

const ViewMoreButton = ({ onClick, disabled, viewMoreMessage = 'Ver más' }: ViewMoreButtonType) => (
  <ViewMoreContainer data-testid="see-more-test" disabled={disabled} onClick={onClick}>
    {viewMoreMessage}
  </ViewMoreContainer>
);

export default ViewMoreButton;
